import React from 'react';

import Chip from 'components/ui/Chip/Chip';
import Icon from 'components/Icon/Icon';
import { LanguageLevelInt, LANG_LEVEL_TO_ICON_NAME } from 'constants/languageLevels';

import css from '../Chip.module.scss';

interface Props extends React.PropsWithChildren {
    beforeContent?: React.ReactNode;
    languageLevel?: LanguageLevelInt;
    allowDelete?: boolean;
    onClick?: () => void;
    onDelete?: () => void;
}

// Chip for input forms
// Todo: Update MultiSelect to use this (or at least these styles)
const InputChip: React.FC<Props> = ({
    beforeContent,
    languageLevel,
    allowDelete = true,
    onDelete,
    children,
    ...rest
}) => {
    return (
        <Chip
            variant="input"
            isCompact
            className={css.inputChip}
            beforeContent={beforeContent}
            afterContent={
                <>
                    {languageLevel && <Icon name={LANG_LEVEL_TO_ICON_NAME[languageLevel]} width={20} color="white" />}
                    {allowDelete && onDelete && (
                        <div onClick={onDelete}>
                            <Icon name="cross" width={16} className={css.inputCloseIcon} color="dark-blue" />
                        </div>
                    )}
                </>
            }
            {...rest}
        >
            {children}
        </Chip>
    );
};

export default React.memo(InputChip);
